import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../shared/Loader";
import { fetcHomehData } from "../../../redux/slices/HomeSlice";

const MapComponent = () => {
  const dispatch = useDispatch();
  const { data, status, error } = useSelector((state) => state.home);

  useEffect(() => {
    dispatch(fetcHomehData());
  }, [dispatch]);

  if (status === "loading") {
    return <Loader />;
  }

  if (status === "failed") {
    return <div>Error: {error}</div>;
  }

  return (
    <div
      style={{ width: "100%", height: "100%" }}
      dangerouslySetInnerHTML={{ __html: data?.data?.settings?.map || "" }}
    />
  );
};

export default MapComponent;
